import React from 'react'
import ContactItem from '../Components/ContactItem';
import ContactForm from '../Components/ContactForm';
import phone from '../img/phone.svg';
import email from '../img/emailme.svg';
import location from '../img/location.svg';
import Tittle from '../Components/Tittle';

import translate from "../Translation/i18nProvider/translate";

function ContactPage() {
  return (
    <div>
      <div className="title">
        <Tittle
          title={translate(
            "contact_main_title1"
          )} /* span={translate("contact_main_title2")}  */
        />
      </div>
      <div className="ContactPage">
        <div className="map-sect">
          <ContactForm />
        </div>
        <div className="contact-sect">
          <ContactItem
            icon={phone}
            text1={""}
            text2={""} /* title={translate("contact_field1_title")} */
          />
          <ContactItem
            icon={email}
            text1={""}
            text2={
              "HubkaMisha@gmail.com"
            } /* title={translate("contact_field2_title")} */
          />
          <ContactItem
            icon={location}
            text1={translate("contact-field_adress_text1")}
            text2={translate(
              "contact-field_adress_text2"
            )} /* title={translate("contact_field3_title")} */
          />
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
